import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      width: '100%',
      display: 'flex',
      padding: 10,
      marginBottom: 15,
      marginTop: 15,
      height: 45,
    },
    select: {
      backgroundColor: 'rgba(255,255,255, 0.04)',
      border: '1px solid black',
      color: 'black',
      borderRadius: 5,
      marginLeft: '15px',
    },
    label: {
      marginLeft: 5,
    },
  }),
);

export default useStyles;
